import { StoryCard } from './types';

interface HeroState {
  lastHeroSongId: string | null;
  lastHeroDate: string | null;
  shownSongIds: string[];
}

const STORAGE_KEY = 'civicbeat_hero_state';

function getTodayDateString(): string {
  const now = new Date();
  return now.toISOString().split('T')[0];
}

function loadHeroState(): HeroState {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Failed to load hero state:', error);
  }
  return {
    lastHeroSongId: null,
    lastHeroDate: null,
    shownSongIds: [],
  };
}

function saveHeroState(state: HeroState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save hero state:', error);
  }
}

function getRandomUnshownSong(songs: StoryCard[], shownSongIds: string[]): StoryCard {
  if (!songs || songs.length === 0) {
    throw new Error('Cannot get random song from empty array');
  }

  const safeShownIds = shownSongIds || [];
  const unshownSongs = songs.filter(song => !safeShownIds.includes(song.id));

  if (unshownSongs.length === 0) {
    const randomIndex = Math.floor(Math.random() * songs.length);
    return songs[randomIndex];
  }

  const randomIndex = Math.floor(Math.random() * unshownSongs.length);
  return unshownSongs[randomIndex];
}

export function getTodaysHeroSong(songs: StoryCard[]): StoryCard | null {
  if (!songs || !Array.isArray(songs) || songs.length === 0) {
    return null;
  }

  const today = getTodayDateString();
  const state = loadHeroState();

  // Ensure shownSongIds is always an array
  const safeShownIds = Array.isArray(state.shownSongIds) ? state.shownSongIds : [];

  if (state.lastHeroDate === today && state.lastHeroSongId) {
    const existingSong = songs.find(song => song.id === state.lastHeroSongId);
    if (existingSong) {
      return existingSong;
    }
  }

  const newHeroSong = getRandomUnshownSong(songs, safeShownIds);

  const updatedShownSongIds = [...safeShownIds, newHeroSong.id];

  if (updatedShownSongIds.length >= songs.length) {
    updatedShownSongIds.length = 0;
  }

  const newState: HeroState = {
    lastHeroSongId: newHeroSong.id,
    lastHeroDate: today,
    shownSongIds: updatedShownSongIds,
  };

  saveHeroState(newState);

  return newHeroSong;
}

export function recordHeroViewed(songId: string): void {
  try {
    const viewKey = 'civicbeat_last_hero_viewed_date';
    const today = getTodayDateString();
    localStorage.setItem(viewKey, today);
  } catch (error) {
    console.error('Failed to record hero view:', error);
  }
}
